import { Action } from "redux";

export type CreatedJiraAcsWorkItemSuccessEvent = Action<typeof CREATED_JIRA_ACS_WORK_ITEM_SUCCESSFULLY>

const createdJiraAcsWorkItemSuccessfully = () => ({
  type: CREATED_JIRA_ACS_WORK_ITEM_SUCCESSFULLY
});

export const CREATED_JIRA_ACS_WORK_ITEM_SUCCESSFULLY = "created_jira_acs_work_item_successfully";

export default createdJiraAcsWorkItemSuccessfully;
